import Splide from '@splidejs/splide';

export class CarouselModule {

	constructor() {
		this.carousels = document.querySelectorAll('.splide');

		if (this.carousels.length) {
			this.init();
		}
	}

	init() {
		const options = {
			perPage: 3,
			perMove: 1,
			gap: '40px',
			pagination: false,
			speed: 600, // transition speed in ms
			easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
			/* breakpoints uses maxwidth */
			breakpoints: {
				767: {
					fixedWidth: 'calc(50% - 20px)', //20px == gap + 8px / 2 (8px = visible overflow in design). 2 is num of items visible
				},
				899: {
					gap: '16px',
				},
				1199: {
					perPage: 2,
				}
		  	}
		};

		const fullWidthOptions = {
			perPage: 1,
			perMove: 1,
			gap: '40px',
			pagination: false,
			speed: 900, // transition speed in ms
			easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
			/* breakpoints uses maxwidth */
			breakpoints: {
				767: {
					fixedWidth: 'calc(100% - 24px)', //24px == gap + 8px (8px = visible overflow in design)
					gap: '16px'
				},
		  	}
		};

		this.carousels.forEach((element) => {
			const isFullwidth = !!element.dataset.fullwidthSlides;

			if (isFullwidth) {
				new Splide(element, fullWidthOptions).mount();
			} else {
				new Splide(element, options).mount();
			}
			
		});
	}

}
